export enum UploadType {
  APK = 'APK',
  IPA = 'IPA',
  AAB = 'AAB',
  APP = 'APP',
  Attachment = 'Attachment',
}
